<template>
  <el-dialog :close-on-click-modal="false" :visible="visible"
             :modal-append-to-body='false' @close="close">
    <el-tabs v-model="viewName">
      <el-tab-pane :label="$t('xiang-qing')" name="detailForm">
        <el-form :model="detailForm" ref="detailForm" size="mini" class="detail_form">
          <el-collapse v-model="activeNames">
            <el-collapse-item :title="$t('ji-ben-xin-xi')" name="basicInformation">
              <el-col :span="12">
                <el-form-item :label="$t('yu-yue-ming-cheng')" :label-width="formLabelWidth" prop="operatorName">
                  <label v-text="detailForm.appointName"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('chuang-jian-shi-jian-0')" :label-width="formLabelWidth">
                  <label v-text="detailForm.createTime"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('yun-ying-shang')" :label-width="formLabelWidth" prop="operatorName">
                  <label v-text="detailForm.operatorName"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('yun-ying-shang-id')" :label-width="formLabelWidth">
                  <label v-text="detailForm.operatorId"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('zhan-dian')" :label-width="formLabelWidth" prop="stationName">
                  <label v-text="detailForm.stationName"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('zhan-dian-id')" :label-width="formLabelWidth">
                  <label v-text="detailForm.stationId"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('sheng-xiao-shi-jian')" :label-width="formLabelWidth">
                  <label v-text="detailForm.beginTime"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('shi-xiao-shi-jian')" :label-width="formLabelWidth">
                  <label v-text="detailForm.endTime"></label>
                </el-form-item>
              </el-col>
            </el-collapse-item>
            <el-collapse-item :title="$t('ke-yu-yue-chong-dian-qiang')" name="gunsformation">
              <el-col :span="24">
                <el-form-item :label="$t('ke-yu-yue-chong-dian-qiang-0')" :label-width="formLabelWidth" prop="gunCode">
                  <el-tree
                    ref="tree"
                    :data="gunTree"
                    :filter-node-method="filterNode"
                    @node-expand="handleNodeExpand">
                  </el-tree>
                </el-form-item>
              </el-col>
            </el-collapse-item>
            <el-collapse-item :title="$t('yu-yue-xin-xi')" name="moreInformation">
              <el-col :span="12">
                <el-form-item :label="$t('yu-yue-yu-zhi')" :label-width="formLabelWidth">
                  <label v-text="detailForm.targetIntegral + $t('ji-fen')"></label>
                </el-form-item>
              </el-col>
              <!--<el-col :span="12">
                <el-form-item label="移动端显示可预约：" :label-width="formLabelWidth">
                  <el-switch
                    v-model="detailForm.showAppointCode"
                    active-value="Y"
                    inactive-value="N"
                    disabled></el-switch>
                </el-form-item>
              </el-col>-->
              <el-col :span="12">
                <el-form-item :label="$t('yu-yue-ti-qian-shi-jian-liang')" :label-width="formLabelWidth">
                  <label v-text="detailForm.appointTimes + $t('fen')"></label>
                </el-form-item>
              </el-col>

              <el-col  :span="12">
                <el-form-item :label="$t('yu-yue-shi-fou-xiao-hao-ji-fen')" :label-width="formLabelWidth">
                  <label v-if="detailForm.appointIsDeduct === 'Y'" v-text="$t('shi')"></label>
                  <label v-if="detailForm.appointIsDeduct === 'N'" v-text="$t('fou')"></label>
                </el-form-item>
              </el-col>

              <el-col v-if="detailForm.appointIsDeduct === 'Y'" :span="12">
                <el-form-item :label="$t('yu-yue-xiao-hao-ji-fen')" :label-width="formLabelWidth">
                  <label v-text="detailForm.appointDeductIntegral + $t('ji-fen')"></label>
                </el-form-item>
              </el-col>

              <el-col v-if="detailForm.maxNum > 0" :span="12">
                <el-form-item   :label="$t('zui-da-shi-yue-ci-shu')" :label-width="formLabelWidth">
                  <label  v-text="detailForm.maxNum + $t('ci')"></label>
                </el-form-item>
              </el-col>

              <el-col v-if="detailForm.maxNum === 0" :span="12">
                <el-form-item   :label="$t('zui-da-shi-yue-ci-shu-0')" :label-width="formLabelWidth">
                  <label  v-text="$t('bu-xian-zhi')"></label>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item :label="$t('shi-yue-kou-fen')" :label-width="formLabelWidth" prop="operatorName">
                  <label v-text="detailForm.deductIntegral + $t('ji-fen')"></label>
                </el-form-item>
              </el-col>

              <el-col v-if="timeSlots != ''" :span="24">
                <el-form-item :label="$t('ke-yu-yue-shi-jian-duan')" :label-width="formLabelWidth">
                  <el-tag :style="{marginRight: '6px'}" :key="index" v-for="(item, index) in timeSlots">
                    {{item}}
                  </el-tag>
                </el-form-item>
              </el-col>

              <el-col v-if="timeSlots === ''" :span="24">
                <el-form-item :label="$t('ke-yu-yue-shi-jian-duan-0')" :label-width="formLabelWidth">
                  <el-tag :style="{marginRight: '6px'}" >
                    {{ $t('24h-sheng-xiao') }}
                  </el-tag>
                </el-form-item>
              </el-col>

              <el-col :span="24">
                <el-form-item :label="$t('yu-yue-miao-shu')" :label-width="formLabelWidth" prop="operatorName">
                  <label v-text="detailForm.desc"></label>
                </el-form-item>
              </el-col>
            </el-collapse-item>
          </el-collapse>
        </el-form>
      </el-tab-pane>
    </el-tabs>
  </el-dialog>
</template>

<script>
    export default {
        name: "detail",
      props: {
        visible: false,
        detailForm: {},
        gunTree: {
          type: Array,
          required: true
        },
      },
      data() {
        return {
          viewName: 'detailForm',
          activeNames: ['basicInformation', 'moreInformation'],
          formLabelWidth: '150px',
        }
      },
      computed: {
        timeSlots() {
          if(this.detailForm.timeSlots) {
            return this.detailForm.timeSlots.split(',')
          }else {
            return ''
          }
        }
      },
      methods: {
        handleNodeExpand(data, node) {
          if(node.level === 1) this.$refs.tree.filter()
        },
        filterNode(value, data, node) {
          return this.detailForm.appointConfGuns.some((item, i) => {
            return item.gunCode === data.id
          })
        },
        close() {
          this.$emit('close', 'detail')
        }
      },

    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/module/resourceCenter/page/appointmentManager/appointmentSettings/detail.vue